<template lang="pug">
div(v-if='cart.state.value.summary.grandTotal !== 0')
  div(
    class='before:border-t before:border-solid before:border-gray-light before:table-cell before:relative before:top-2 before:w-1/5 before:right-[5%] after:border-t after:border-solid after:border-gray-light after:table-cell after:relative after:top-2 after:w-1/5 after:left-[5%] table text-lg text-black whitespace-nowrap m-auto font-bold leading-5 my-4'
  ) Or Checkout With
  div(v-if='!route.query.checkout_token' class='mb-5')
    StripePaymentRequestButtonV2(
      v-if='isIntegrationEnabled("stripe") && $sitewideConfig.config.stripePaymentRequestButton'
      class='mb-4'
      :cart='cart'
    )
    PaypalButtonV2(v-if='isIntegrationEnabled("paypal")' :cart='cart' :button-id='buttonId')

  div(v-if='isIntegrationEnabled("affirm")')
    div(
      class='before:border-t before:border-solid before:border-gray-light before:table-cell before:relative before:top-2 before:w-1/5 before:right-[5%] after:border-t after:border-solid after:border-gray-light after:table-cell after:relative after:top-2 after:w-1/5 after:left-[5%] table text-lg text-black whitespace-nowrap m-auto font-bold leading-5 my-4'
    ) Or Buy Now, Pay Later
    AffirmButton(@click='startAffirm')
    template(v-if='route.name === "checkout-cart"')
      AffirmInfo(class='mt-3')
</template>

<script setup lang="ts">
const { $sitewideConfig } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()
const route = useRoute()
const cart = useCart()

const buttonId = computed(() => {
  return route.name === 'checkout-cart' ? 'paypal-button-cart' : 'paypal-button-payment'
})

function startAffirm() {
  navigateTo('/checkout/affirm/')
}
</script>
